/* "Acquista" nelle card Broker Ricambi: aggiunge al carrello e va dritto alla cassa.
   Il tasto "Carrello" usa invece il form nativo del tema (carrello AJAX). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.brh-btn--buy') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('brh-btn--loading')) return;

    var id = btn.getAttribute('data-brh-buy');
    if (!id) { window.location.href = '/cart'; return; }

    btn.classList.add('brh-btn--loading');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.ok ? '/checkout' : '/cart'; })
      .then(function (dest) { window.location.href = dest; })
      .catch(function () { window.location.href = '/cart'; });
  });
})();
